export default "__VITE_ASSET__J2_38kH5__"